import { Controller } from '@hotwired/stimulus'
import { loadApexCharts } from '../utils/chart_loader'

export default class extends Controller {
  static values = {
    series: Array,  // Array of series objects: [{ name: 'AI', data: [...] }, { name: 'Human', data: [...] }]
    categories: Array  // X-axis labels (dates)
  }

  connect() {
    this.initializeChart()
  }

  disconnect() {
    if (this.chart) {
      this.chart.destroy()
    }
  }

  async initializeChart() {
    if (this.chart) {
      this.chart.destroy()
    }

    const ApexCharts = (await loadApexCharts()).default

    const options = {
      chart: {
        type: 'line',
        height: 350,
        toolbar: {
          show: true,
          tools: {
            download: true,
            zoom: true,
            zoomin: true,
            zoomout: true,
            pan: true,
            reset: true
          }
        },
        fontFamily: 'Inter, system-ui, sans-serif',
        animations: {
          enabled: true,
          easing: 'easeinout',
          speed: 800
        },
        zoom: {
          enabled: true,
          type: 'x'
        }
      },
      colors: ['#FBBF24', '#8B5CF6', '#10B981'],
      stroke: {
        width: 3,
        curve: 'smooth'
      },
      series: this.seriesValue,
      xaxis: {
        categories: this.categoriesValue,
        title: {
          text: 'Período',
          style: {
            fontSize: '12px',
            fontWeight: 600,
            color: '#6b7280'
          }
        },
        labels: {
          style: {
            colors: '#9ca3af',
            fontSize: '11px'
          },
          rotate: -45,
          rotateAlways: false
        }
      },
      yaxis: {
        title: {
          text: 'Número de Respostas',
          style: {
            fontSize: '12px',
            fontWeight: 600,
            color: '#6b7280'
          }
        },
        labels: {
          style: {
            colors: '#9ca3af',
            fontSize: '11px'
          },
          formatter: (value) => Math.round(value)
        }
      },
      grid: {
        borderColor: '#f3f4f6',
        strokeDashArray: 4,
        xaxis: {
          lines: { show: true }
        },
        yaxis: {
          lines: { show: true }
        }
      },
      dataLabels: {
        enabled: false
      },
      markers: {
        size: 4,
        hover: {
          size: 6
        }
      },
      tooltip: {
        enabled: true,
        shared: true,
        intersect: false,
        theme: 'light',
        style: { fontSize: '12px' },
        y: {
          formatter: (value) => `${value} resposta${value !== 1 ? 's' : ''}`
        }
      },
      legend: {
        show: true,
        position: 'top',
        horizontalAlign: 'right',
        fontSize: '12px',
        fontWeight: 500,
        labels: {
          colors: '#374151'
        },
        markers: {
          width: 10,
          height: 10,
          radius: 10
        }
      },
      fill: {
        type: 'gradient',
        gradient: {
          shade: 'light',
          type: 'vertical',
          shadeIntensity: 0.1,
          opacityFrom: 0.4,
          opacityTo: 0.1,
          stops: [0, 100]
        }
      }
    }

    this.chart = new ApexCharts(this.element, options)
    this.chart.render()
  }
}
